<template>
    <div class="tw-animate-pulse tw-rounded-[10px] tw-w-full tw-h-[100px] tw-bg-[#F2F2F2] dark:tw-bg-[#002039] tw-mt-3"></div>
</template>
